import React, { useEffect } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom'
import { useMutation } from 'react-query';
import createPersistedState from 'use-persisted-state';

import useLocalStorage from 'hooks/useLocalStorage'
import { fetcher } from 'api/client';
import { noop } from 'utils';
import { login, respondChallenge } from 'api/actions/auth';

const AuthContext = React.createContext();
const useAuthPersistedState = createPersistedState('auth');


function AuthProvider({ children }) {
    const auth = useProvideAuth({});
    return (
        <AuthContext.Provider value={auth}>
            {children}
        </AuthContext.Provider>
    )
}

function useAuth() {
    const context = React.useContext(AuthContext)
    if (context === undefined) {
        throw new Error('useAuth must be used within a AuthProvider')
    }
    return context
}

function useProvideAuth() {
    const [auth, setAuth] = useAuthPersistedState({});
    

    const signin = (auth, cb = noop) => {
        setAuth(auth);
        localStorage.setItem('jwt', auth.accessToken)
        localStorage.setItem('id_token', auth.idToken)
        localStorage.setItem('refreshToken', auth.refreshToken)
        localStorage.setItem('expiresIn', auth.expiresIn)
        localStorage.setItem('expiresAt', auth.expiresAt)
        localStorage.setItem('tokenType', 'Bearer')
        cb();
    };
  
    const singout = (cb) => {
        setAuth({})
        localStorage.removeItem('jwt')
        localStorage.removeItem('id_token')
        localStorage.removeItem('refreshToken')
        localStorage.removeItem('expiresIn')
        localStorage.removeItem('expiresAt')
        localStorage.removeItem('tokenType')
        cb();
    };

    return {
      auth,
      signin,
      singout
    };
  }
  


export { AuthProvider, useAuth }